import React, { useState, useEffect } from "react";
import { lifestyleApi } from "../apiService/api";

const AllPreviousPdf = () => {
  const [reports, setReports] = useState([]);

  const fetchReports = async () => {
    try {
      const res = await lifestyleApi.fetchWFIRSSReports();
      setReports(res.data.data.wfirss || []);
    } catch (err) {
      console.error("fetchWFIRSSReports:", err);
    }
  };

  useEffect(() => { fetchReports(); }, []);

  const deleteReport = async (scoreId) => {
    try {
      const res = await lifestyleApi.removeWFIRSSReport({ scoreId });
      if (res.data.data.message === "Report Deleted") fetchReports();
    } catch (err) {
      console.error("removeWFIRSSReport:", err);
    }
  };

  if (!reports || reports.length <= 1) return null;

  return (
    <section className="all-pdf-section">
      {reports
        .filter((r) => r.reportUrl)
        .map((report, index) => (
          <div key={index} className="all-pdf-card">
            <a
              href={`https://goqii.com/app?fsn=244&fssn=0&fai=%7B%22url%22%3A%22${encodeURIComponent(report.reportUrl)}%22%2C%22title%22%3A%22WFIRSS-Report%22%7D`}
              className="all-pdf-link"
            >
              <img
                src="https://appcdn.goqii.com/storeimg/45653_1716376691.png"
                className="all-pdf-thumb"
                alt="report"
              />
              <div className="all-pdf-info">
                <h1 className="all-pdf-title">WFIRS-S {index + 1}</h1>
                <h2 className="all-pdf-date">{report.logDate}</h2>
              </div>
            </a>
            <button className="all-pdf-delete" onClick={() => deleteReport(report.scoreId)}>
              &#128465;
            </button>
          </div>
        ))}
    </section>
  );
};

export default AllPreviousPdf;
